export const pixelsToRem = (...args: (string | number)[]): string =>
  args.map((arg: string | number) => (typeof arg === 'number' ? `${arg / 16}rem` : arg)).join(' ');

export default pixelsToRem;
